import { Outlet, useRoutes } from "react-router-dom";
import { LoadComponent } from "@loadComponent";
import Layout from "./Layout";
import { lazy } from "react";
import { ClientListSuspense } from "_pages/service/queue/ClientsList";

const ClientsList = lazy(() => import("_pages/service/queue/ClientsList"));
const ChatRoom = lazy(() => import("_pages/service/queue/ChatRoom"));
const ViewAttendance = lazy(() => import("_pages/service/queue/components/ViewAttendance"));


const Queue = () => {
    return useRoutes([
        {
            path: '',
            element: <LoadComponent component={Layout} />,
            children: [
                {
                    path: '',
                    element: <LoadComponent component={ClientsList} fallback={<ClientListSuspense />} />,
                },
                {
                    path: ':id',
                    children: [
                        {
                            path: '',
                            element: <LoadComponent component={ChatRoom} />,
                        },
                        {
                            path: 'view',
                            element: <LoadComponent component={ViewAttendance} />,
                        }
                    ],
                }
            ],
        }
    ]);
};


export default Queue;
